import React, { FC } from 'react'
import { Navigate } from 'react-router-dom'

// 旧・指導分析ページ。統計ページの概況タブ (対象セレクタで薬剤師軸を選択) に統合済み
export const GuidanceAnalysisPage: FC = () => (
  <Navigate to="/portal/metrics?tab=overview" replace />
)
